<template>
    <div>
        <b-alert v-if="alerta_pre_cadastro" show variant="warning">{{mensagem_pre_cadastro}}</b-alert>
        <b-row>
            <b-col cols="12">
                <b-form-group label="Nome Instituição:">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-university" aria-hidden="true"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      placeholder="Nome Instituição"
                                      autocomplete="nomeInstituicao"
                                      v-model.trim="$v.form.nomeInstituicao.$model"
                                      :state="chkState('nomeInstituicao')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback3">O Nome da Instituição é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-form-group label="CNPJ:">
                    <b-input-group class="mb-6">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-industry" aria-hidden="true"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-mask="'##.###.###/####-##'"
                                      type="text"
                                      class="form-control"
                                      placeholder="CNPJ"
                                      autocomplete="cnpj"
                                      v-model="$v.form.cnpj.$model"
                                      :state="chkState('cnpj')"
                                      autofocus/>
                        <b-form-invalid-feedback id="input1LiveFeedback1">CNPJ é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group label="UF:">
                    <b-form-select v-model.lazy.trim="$v.form.uf.$model" placeholder="Password" :options="estados"
                                   class="mb-3" :state="chkState('uf')">
                        <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="Município:"
                              :disabled="disabled_cidades">
                    <b-form-select placeholder="Password"
                                   :options="cidades"
                                   class="mb-3"
                                   v-model.lazy.trim="$v.form.municipio.$model"
                                   :state="chkState('municipio')">
                        <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-form-group label="DDD + Telefone">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      v-mask="'+55 (##) #####-####'"
                                      class="form-control"
                                      placeholder="Telefone"
                                      autocomplete="telefone"
                                      v-model.lazy.trim="$v.form.telefone.$model"
                                      :state="chkState('telefone')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group label="Matrícula">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-child" aria-hidden="true"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      v-mask="'####################'"
                                      placeholder="Matrícula"
                                      autocomplete="matricula"
                                      v-model.lazy.trim="$v.form.matricula.$model"
                                      :state="chkState('matricula')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">A Matrícula é obrigatória, e deve ter 20 caractéres.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group label="Dependência Administrativa:">
                    <b-form-select placeholder="Dependência Administrativa"
                                   :options="dependencias"
                                   class="mb-3"
                                   v-model.lazy.trim="$v.form.dependenciaAdministrativa.$model"
                                   :state="chkState('dependenciaAdministrativa')">
                        <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback6">Dependência Administrativa é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-form-group label="CEP">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-address-card" aria-hidden="true"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      v-mask="'#####-###'"
                                      class="form-control"
                                      placeholder="Cep"
                                      autocomplete="cep"
                                      v-model.lazy.trim="$v.form.cep.$model"
                                      :state="chkState('cep')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">O CEP é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="8">
                <b-form-group label="Endereço:">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-map-signs" aria-hidden="true"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      placeholder="Endereço"
                                      autocomplete="endereco"
                                      v-model.trim="$v.form.endereco.$model"
                                      :state="chkState('endereco')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">O Endereço é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="2">
                <b-form-group label="Número:">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      placeholder="Número"
                                      v-mask="'######'"
                                      autocomplete="numero"
                                      v-model.trim="$v.form.numeroInstitucional.$model"
                                      :state="chkState('numeroInstitucional')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">O Número é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="5">
                <b-form-group label="Complemento:">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      placeholder="Complemento"
                                      autocomplete="complemento"
                                      v-model.trim="$v.form.complementoInstitucional"
                                      />
                        <b-form-invalid-feedback id="input1LiveFeedback4">O Complemento é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="5">
                <b-form-group label="Bairro:">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input type="text"
                                      class="form-control"
                                      placeholder="Bairro"
                                      autocomplete="bairro"
                                      v-model.trim="$v.form.bairroInstitucional.$model"
                                      :state="chkState('bairroInstitucional')"/>
                        <b-form-invalid-feedback id="input1LiveFeedback4">O Bairro é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-form-file multiple browse-text="Anexar Documento">
                <template slot="file-name" slot-scope="{ names }">
                    <b-badge variant="primary">{{ names[0] }}</b-badge>
                    <b-badge variant="primary">{{ names[1] }}</b-badge>
                    <b-badge variant="primary">{{ names[2] }}</b-badge>
                    <b-badge v-if="names.length > 3" variant="primary" class="ml-1">
                        + {{ names.length - 1 }} Arquivos
                    </b-badge>
                </template>
            </b-form-file>
        </b-row>
        <br/>
        <b-row>
            <b-col class="align-items-center" cols="4">
                <b-button v-if="!loading" variant="primary" class="btn btn-outline-light btn-block" v-on:click="onSubmit()">Criar Usuário</b-button>
                <b-button v-else variant="primary" class="btn btn-block" disabled>
                    <b-spinner small type="grow"></b-spinner>Salvando...
                </b-button>
            </b-col>
            <b-col cols="4">
                <b-button variant="primary" class="btn btn-outline-light btn-block" v-if="externo" @click="navigate('/login')">Voltar para a tela de Acesso</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  nomeInstituicao: '',
  cnpj: '',
  uf: null,
  municipio: null,
  telefone: '',
  matricula: '',
  dependenciaAdministrativa: null,
  cep: '',
  endereco: '',
  bairroInstitucional: '',
  complementoInstitucional: '',
  numeroInstitucional: ''
}

export default {
  name: 'DadosInstitucionais',
  components: {
    AuthTemplate,
    VueSelect
  },
  props: [],
  mixins: [validationMixin],
  validations: {
    form: {
      nomeInstituicao: {
        required
      },
      cnpj: {
        required
      },
      matricula: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(20)
      },
      bairroInstitucional: {
        required
      },
      numeroInstitucional: {
        required,
        maxLength: maxLength(6),
        minLength: minLength(6)
      },
      telefone: {
        required
      },
      dependenciaAdministrativa: {
        required
      },
      uf: {
        required
      },
      municipio: {
        required
      },
      cep: {
        required,
        maxLength: maxLength(9),
        minLength: minLength(9)
      },
      endereco: {
        required
      }
    }
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarDependencias')
  },
  data () {
    return {
      externo: true,
      loading: false,
      salvarForm: false,
      form: Object.assign({}, formShape),
      text: 'Declaro, para os devidos fins, que concordo com o armazenamento dos meus dados pessoais para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.',
      status_aceite: 'not_accepted',
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteTipoUsuario: false,
      valueAceiteCadastro: false,
      titulo_toast: 'Alerta!',
      options: [
        {value: true}
      ],
      options2: [
        {value: true}
      ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: '',
      tabs: ['Dados Pessoais', 'Dados Institucionais'],
      dados_pessoais: []
    }
  },
  mounted () {
    if (this.$router.currentRoute.fullPath === '/usuario/cadastrar') {
      this.externo = false
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    dependencias () {
      return this.$store.state.dependencias.listaDependencias
    }
  },
  watch: {
    '$v.form.uf.$model': function () {
      if (this.$v.form.uf.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.$v.form.uf.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    }
  },
  methods: {
    onSubmit () {
      this.salvarForm = true

      if (this.validate()) {
        this.salvar()
      }
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    chkState (val) {
      const field = this.$v.form[val]

      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    salvar: function () {
      this.loading = true
      this.dados_pessoais = SessionStorage.get('dados_pessoais', [])

      if (!this.dados_pessoais.length) {
        this.$emit('trocarabaativa')
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Preecha seus dados pessoais!', 'Alerta', 5000)
        this.loading = false
        return
      }

      let form = this.$v.form

      let dadosInstitucionais = {
        di_nome_instituicao: form.nomeInstituicao.$model,
        di_cnpj: form.cnpj.$model.replace(/[^\d]+/g, ''),
        di_matricula: form.matricula.$model.replace(/[^\d]+/g, ''),
        di_municipio_id: parseInt(form.municipio.$model),
        di_telefone: form.cep.$model.replace(/[^\d]+/g, ''),
        di_dependencia_administrativa: form.dependenciaAdministrativa.$model,
        di_cep: form.cep.$model.replace(/[^\d]+/g, ''),
        di_endereco: form.endereco.$model,
        di_bairro: form.bairroInstitucional.$model,
        di_complemento: form.complementoInstitucional,
        di_numero: form.numeroInstitucional.$model.replace(/[^\d]+/g, '')
      }

      let dadosPessoais = JSON.parse(this.dados_pessoais)

      let data = jQuery.extend(dadosInstitucionais, dadosPessoais)

      Vue.http.post('api/usuario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          SessionStorage.remove('dados_pessoais')
          this.loading = false
          if (this.externo) {
            this.$router.push({path: '/login'})
          } else {
            this.$router.push({path: '/usuarios'})
          }
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          this.loading = false
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        let response = e.body

        if (response.data) {
          let erros = Object.values(response.data)

          for (let erro of erros) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(erro, 'Ops!', 9000)
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/auth/DadosInstitucionais.vue